// removed by extract-text-webpack-plugin
module.exports = {"root":"CentricUI__components__ImageSourceToolbarButton__root","menu":"CentricUI__components__ImageSourceToolbarButton__menu","imageSourceMenuItem":"CentricUI__components__ImageSourceToolbarButton__imageSourceMenuItem","inlineButtons":"CentricUI__components__ImageSourceToolbarButton__inlineButtons","sectionLabel":"CentricUI__components__ImageSourceToolbarButton__sectionLabel","imageSourceButton":"CentricUI__components__ImageSourceToolbarButton__imageSourceButton"};


//////////////////
// WEBPACK FOOTER
// ./src/modules/catalog/internal/topBar/components/ImageSourceToolbarButton.css
// module id = 1556
// module chunks = 10